(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-bar')) {
    customElements.define('marquee-bar', class extends HTMLElement {
      connectedCallback() {
        const toggle = this.querySelector('[data-motion-toggle]');
        if (!toggle) return;
        this.onToggle = () => {
          const paused = this.classList.toggle('is-paused');
          toggle.setAttribute('aria-pressed', String(paused));
          const label = paused ? 'Resume announcements' : 'Pause announcements';
          toggle.setAttribute('aria-label', label);
          toggle.title = label;
        };
        toggle.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.querySelector('[data-motion-toggle]')?.removeEventListener('click', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    


    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url).then(response => response.text()).then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    }).catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials-carousel"] && !Shopify.designMode) return;
  try {
    
  class VideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
      this.prevButton = this.querySelector('.scroll-button-prev');
      this.nextButton = this.querySelector('.scroll-button-next');
      this.floatingPlayer = this.querySelector('[data-floating-player]');
      this.floatingMedia = this.querySelector('[data-floating-media]');
      this.closeButton = this.querySelector('[data-close-player]');
      this.activeFloatingVideo = null;
      this.lastTrigger = null;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      }
      this.cards.forEach((card) => {
        card.addEventListener('click', () => this.openFloatingPlayer(card));
      });
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeFloatingPlayer());
      }
      this.onEscape = (event) => {
        if (event.key === 'Escape' && !this.floatingPlayer.hidden) this.closeFloatingPlayer();
      };
      document.addEventListener('keydown', this.onEscape);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onEscape);
    }

    scrollByCard(direction) {
      if (!this.track) return;
      const firstCard = this.cards[0];
      const amount = firstCard ? firstCard.getBoundingClientRect().width + 22 : 320;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: amount * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* ---- Build the player only after a visitor activates a card ---- */
    openFloatingPlayer(card) {
      const sourcesScript = card.querySelector('[data-video-sources]');
      if (!sourcesScript || !this.floatingPlayer || !this.floatingMedia) return;
      let sources;
      try { sources = JSON.parse(sourcesScript.textContent); } catch { return; }
      if (!sources.length) return;

      if (this.activeFloatingVideo) this.activeFloatingVideo.pause();
      const closeButton = this.closeButton;
      this.floatingMedia.innerHTML = '';
      if (closeButton) this.floatingMedia.appendChild(closeButton);

      const floatingVideo = document.createElement('video');
      floatingVideo.controls = true;
      floatingVideo.playsInline = true;
      floatingVideo.preload = 'metadata';
      floatingVideo.setAttribute('aria-label', card.getAttribute('aria-label').replace(/^Play video: /, 'Video: '));
      sources.forEach((src) => {
        const source = document.createElement('source');
        source.src = src.url;
        source.type = src.type;
        floatingVideo.appendChild(source);
      });

      this.floatingMedia.appendChild(floatingVideo);
      this.floatingPlayer.hidden = false;
      this.activeFloatingVideo = floatingVideo;
      this.lastTrigger = card;
      this.closeButton.focus();
      floatingVideo.load();
      floatingVideo.play().catch(() => {});
    }

    closeFloatingPlayer() {
      if (!this.floatingPlayer || !this.floatingMedia || this.floatingPlayer.hidden) return;
      if (this.activeFloatingVideo) this.activeFloatingVideo.pause();
      this.floatingMedia.querySelectorAll('video').forEach((v) => v.remove());
      this.floatingPlayer.hidden = true;
      this.activeFloatingVideo = null;
      if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus();
      this.lastTrigger = null;
    }
  }

  if (!customElements.get('video-carousel')) {
    customElements.define('video-carousel', VideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
